"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.patch = exports.post = exports.get = void 0;
const validation_1 = __importDefault(require("../../../../validation"));
const rules_1 = __importDefault(require("../../../../validation/rules"));
const getParamRules = {
    id: validation_1.default.rules.string().required().label('Organization ID'),
    productId: validation_1.default.rules.string().required().label('Product ID'),
};
const getParams = {
    rules: getParamRules,
    schema: validation_1.default.schema(getParamRules),
};
exports.get = { params: getParams };
const postBodyRules = {
    name: rules_1.default.string().required().label('Product Name'),
    annotatorRefId: rules_1.default.string().label('Annotator Ref Id'),
    type: rules_1.default.string().required().label('Product Type'),
    categories: rules_1.default.array().required().of(rules_1.default.string().required()).min(1, 'Product category is required')
        .label('Product Categories'),
    policyUrl: rules_1.default.string().url().label('Privacy Policy Url'),
    distributionMethods: rules_1.default.array().optional().of(rules_1.default.string().required())
        .when('type', {
        is: 'Mobile App',
        then: () => rules_1.default.array().required().of(rules_1.default.string().required())
            .min(1, 'Product distribution method is required if product type is Mobile App.')
            .label('Product Distribution Methods'),
        otherwise: () => rules_1.default.array().notRequired(),
    }),
    privacyPolicyIntroduction: rules_1.default.string().optional().label('Privacy Policy Introduction'),
};
const postParamRules = { id: validation_1.default.rules.string().required().label('Id') };
const postParams = {
    rules: postParamRules,
    schema: validation_1.default.schema(postParamRules),
};
const postBody = {
    rules: postBodyRules,
    schema: validation_1.default.schema(postBodyRules),
};
// eslint-disable-next-line import/prefer-default-export
exports.post = {
    body: postBody,
    params: postParams,
};
const patchBodyRules = {
    type: rules_1.default.string().required().label('Product Type'),
    categories: rules_1.default.array().required().of(rules_1.default.string().required()).min(1, 'Product category is required')
        .label('Product Categories'),
    distributionMethods: rules_1.default.array().optional().of(rules_1.default.string().required())
        .when('type', {
        is: 'Mobile App',
        then: () => rules_1.default.array().required().of(rules_1.default.string().required())
            .min(1, 'Product distribution method is required if product type is Mobile App.')
            .label('Product Distribution Methods'),
        otherwise: () => rules_1.default.array().notRequired(),
    }),
    privacyPolicyIntroduction: rules_1.default.string().optional().label('Privacy Policy Introduction'),
};
const patchBody = {
    rules: patchBodyRules,
    schema: validation_1.default.schema(patchBodyRules),
};
const patchParamRules = {
    id: validation_1.default.rules.string().required().label('Organization Id'),
    productId: validation_1.default.rules.string().required().label('Product Id'),
};
const patchParams = {
    rules: patchParamRules,
    schema: validation_1.default.schema(patchParamRules),
};
exports.patch = {
    body: patchBody,
    params: patchParams,
};
